interface AppConfig {
    baseApiUrl: string;
}

export const APP_CONFIG: AppConfig = {
    baseApiUrl: process.env.REACT_APP_BASE_API_URL as string,
};
